import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";
import save from "../../../assets/save-icon.png";
import cancel from "../../../assets/cancel-icon.png";

const ModifyOrganization = (props) => {

	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);

	const organizationNameInputRef = useRef();
	const formatInputRef = useRef();
	const remarkInputRef = useRef();

	const [dataToBeSelect, setDataToBeSelect] = useState([]);
	const [systemList, setSystemList] = useState([]);

	const [editData, setEditData] = useState([]);
	const [inputError, setInputError] = useState([]);

	const [dateFormat, setDateFormat] = useState('yyyyMM');
	const [mthCountFormat, setMthCountFormat] = useState('####');

	//#region Style
	const th = {
	  fontWeight: "normal",
	};
  
	const thInput = {
	  fontWeight: "normal",
	  border: "1px solid #ced4da",
	};
	//#endregion

    useEffect(() => {
		if (props.dataToBeSelect !== undefined && props.dataToBeSelect !== null) {
			setDataToBeSelect({
				OrganizationCat: props.dataToBeSelect.OrganizationCat === null ? [] : props.dataToBeSelect.OrganizationCat,
				System: props.dataToBeSelect.System === null ? [] : props.dataToBeSelect.System,
			});
		};
	}, [props.dataToBeSelect]);

	
    useEffect(() => {

		if (props.editData !== null) {
			// const ticketNumFormat = props.editData.FORMAT;
			// let format = '';
			// if (typeof(ticketNumFormat) === 'string') {
			// 	setDateFormat(ticketNumFormat.split('-')[1]);
			// 	setMthCountFormat(ticketNumFormat.split('-')[2]);
			// }
			
			setEditData({
				ORG_ID: props.editData.ORG_ID,
				ORG_NAME: props.editData.ORG_NAME,
				ORG_CATEGORY: props.editData.ORG_CATEGORY_ID === null ? "" :
					{
						key: props.editData.ORG_CATEGORY_ID,
						value: props.editData.ORG_CATEGORY_ID,
						label: props.editData.ORG_CATEGORY_NAME,
					},
				FORMAT: props.editData.FORMAT === null ? "" : props.editData.FORMAT,
				// FORMAT: format = ticketNumFormat ? ticketNumFormat.split('-')[0] : "",
				REMARK: props.editData.REMARK === null ? "" : props.editData.REMARK,
			});
			const systemId = props.editData.SYSTEM_MST_ID === null || props.editData.SYSTEM_MST_ID === undefined ? "" : props.editData.SYSTEM_MST_ID.split(",");
			const systemName = props.editData.SYSTEM_MST_NAME === null || props.editData.SYSTEM_MST_NAME === undefined ? "" : props.editData.SYSTEM_MST_NAME.split(",");

			const system = [];
			for (var i = 0; i < systemId.length; i++){
				system.push({
					key: systemId[i],
					value: systemId[i],
					label: systemName[i],
				})
			}
			setSystemList(system);
		}
	}, [props.editData]);

	//#region Modal Show/Hide
	const hideModal = () => {
		setInputError([]);
		props.onHide();
	};
	//#endregion

	const saveBtnOnClick = () => {

		if (Object.values(inputError).filter(v => v !== "").length === 0) {
			SaveEditOrganization();
		}
	}

    function SaveEditOrganization() {
		let functionName = "";
		try {
			functionName = SaveEditOrganization.name;
			props.onLoading(true, "Modifying organization, please wait...");
			const selectedSystemList = systemList.map((s) => s.key);
			const data = {
				ORG_ID: editData.ORG_ID,
				ORG_NAME: editData.ORG_NAME.trim(),
				ORG_CATEGORY_ID: editData.ORG_CATEGORY.key,
				ORG_CATEGORY_NAME: editData.ORG_CATEGORY.label,
				ORG_SYSTEM_LIST: selectedSystemList,
				// TICKET_NUM_FORMAT_ID: editData.TICKET_NUM_FORMAT.key,
				FORMAT: editData.FORMAT,
				// FORMAT: editData.FORMAT + '-' + dateFormat + '-' + mthCountFormat,
				REMARK: editData.REMARK === undefined ? "" : editData.REMARK.trim(),
				UPDATE_ID: userId,
			};
			http
				.put("api/Organization/UpdateOrg", data, { timeout: 5000 })
				.then((response) => {
					if (response.data.DUPLICATE_ORG_NAME === true) {
						toast.error("Organization already exist.");
					} 
					// else if (response.data.DUPLICATE_FORMAT === true) {
					// 	toast.error("Ticket Number Format already exist.");
					// } 
					else {
						toast.success("Organization is successfully modified.");
						props.onReload();
						hideModal();
					}
				})
				.catch((err) => {
					toast.error("Failed to modify organization. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					props.onLoading(false, "Loading...");
				});
		} catch (err) {
			props.onLoading(false, "Loading...");
			toast.error("Failed to modify organization. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};

    const inputRequiredHandler = (event) => {
		let functionName = "";

		try {
			functionName = inputRequiredHandler.name;
			const name = event.target.name;
			functionName = inputRequiredHandler.name + "_" + name;
			const id = event.target.id;
			const val = event.target.value;
			if (val.length === 0 || val.trim().length === 0) {
				setInputError((prevState) => ({
					...prevState,
					[id]: (name + " could not be empty."),
				}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					[id]: (""),
				}));
			}
			setEditData((prevState) => ({
				...prevState,
				[id]: val,
			}));
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
	}

	const inputUnrequiredHandler = (event) => {
		let functionName = "";

		try {
			functionName = inputUnrequiredHandler.name;
			const name = event.target.name;
			functionName = inputUnrequiredHandler.name + "_" + name;
			const id = event.target.id;
			const val = event.target.value;

			setEditData((prevState) => ({
				...prevState,
				[id]: val,
			}));
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
	}

	const selectionHandler = (val, field) => {
		let functionName = "";
	
		try {
		  functionName = selectionHandler.name;
		  setInputError((prevState) => ({
			...prevState,
			[field]: "",
		  }));
		  setEditData((prevState) => ({
			...prevState,
			[field]: val, //Document type
		  }));
		} catch (err) {
		  common.c_LogWebError(props.page, functionName, err);
		}
	  };

	const selectSystemHandler = (val) => {
		let functionName = "";

		try {
		functionName = selectSystemHandler.name;
		if (Object.keys(val).length > 0) {
			setInputError((prevState) => ({
			...prevState,
			SYSTEM_USED: "",
			}));
		} else {
			setInputError((prevState) => ({
			...prevState,
			SYSTEM_USED: "System used could not be empty.",
			}));
		}
		setSystemList([...val]);
		} catch (err) {
		common.c_LogWebError(props.page, functionName, err);
		}
	}

    return (
		<>
			<Modal show={props.showHide} onHide={hideModal} centered>
				<Modal.Header>
					<div style={{ backgroundColor: "lightgrey", width: "100%" }}>
						<Modal.Title>MODIFY</Modal.Title>
					</div>
				</Modal.Header>
				<Modal.Body>
					<Comp.Input
						ref={organizationNameInputRef}
						id="ORG_NAME"
						label="Organization Name*:"
						name="Organization Name"
						type="text"
						className="form-control"
						errorMessage={inputError.ORG_NAME}
						value={editData.ORG_NAME}
						onChange={inputRequiredHandler}
					/>
					<Comp.Select
						id="ORG_CATEGORY"
						label="Organization Category*:"
						type="text"
						options={dataToBeSelect.OrganizationCat}
						closeMenuOnSelect={true}
						hideSelectedOptions={false}
						errorMessage={inputError.ORG_CATEGORY}
						value={editData.ORG_CATEGORY}
						onChange={(val) => selectionHandler(val, "ORG_CATEGORY")}
					/>
					<Comp.Select
						id="SYSTEM_USED"
						label="System Used*:"
						type="text"
						options={dataToBeSelect.System}
						closeMenuOnSelect={true}
						hideSelectedOptions={false}
						errorMessage={inputError.SYSTEM_USED}
						value={systemList}
						onChange={selectSystemHandler}
						isMulti
					/>
					<Comp.Input
						ref={formatInputRef}
						id="FORMAT"
						label="Ticket Number Format*:"
						name="Ticket Number Format"
						type="text"
						className="form-control"
						// errorMessage={inputError.FORMAT}
						value={editData.FORMAT}
						// onChange={inputRequiredHandler}
						disabled={true}
					/>
					{/* <label>Ticket Number Format*:</label>
					<div>
						<form>
						<table >
							<thead>
							<tr>
								<th style={{textAlign: "center"}}>[Organization]</th>
								<th>-</th>
								<th style={{textAlign: "center"}}>[Date Format]</th>
								<th>-</th>
								<th style={{textAlign: "center"}}>[Count]</th>      
							</tr>
							</thead>
							<tbody>
							<tr>
								<th width={"130px"} style={thInput}>
									<Comp.Input
									// ref={formatInputRef}
									id="FORMAT"
									type="text"
									placeholder="[Organization]"
									className="form-control"
									width="10px"
									errorMessage={inputError.FORMAT}
									value={editData.FORMAT}
									onChange={inputRequiredHandler}
									/>
								</th>
								<th style={th}>-</th>
								<th width={"110px"} style={thInput}>
									<Comp.Input
									id="DATE_FORMAT"
									value={dateFormat}
									readOnly={true}
									/>
								</th>
								<th style={th}>-</th>
								<th  width={"70px"} style={thInput}>
									<Comp.Input
									id="COUNT_FORMAT"
									value={mthCountFormat}
									readOnly={true}
									/>      
								</th>   
							</tr>
							</tbody>
						</table>
						</form>
					</div> */}
                    <Comp.Input
						ref={remarkInputRef}
						id="REMARK"
						label="Remark:"
						type="text"
						className="form-control"
						value={editData.REMARK}
						onChange={inputUnrequiredHandler}
					/>
				</Modal.Body>
				<Modal.Footer>
					<div style={{ textAlign: "center", width: "100%" }}>
						<Comp.Button id="btnSave" onClick={saveBtnOnClick}>
							Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
						</Comp.Button>
						&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
						<Comp.Button
							id="btnCancel"
							type="cancel"
							onClick={hideModal}
						>
							Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
						</Comp.Button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);

};

export default ModifyOrganization;